import "./assets/RideIcon.css";
const i = {
  "ride-icon": "_ride-icon_dkhm4_1",
  "size-small": "_size-small_dkhm4_6",
  "size-medium": "_size-medium_dkhm4_10",
  "size-large": "_size-large_dkhm4_14",
  "size-x-large": "_size-x-large_dkhm4_18"
};
export {
  i as s
};
